export const ACTUAL_ROW_CONFIG = {
	text: {
		minWidth: 120,
	}
}